"use client";

import Image from "next/image";
import Link from "next/link";

const PARTNERS: { name: string; logo: string; href?: string }[] = [
    { name: "Ruijie", logo: "/images/partners/ruijie.png" },
    { name: "Lansan", logo: "/images/partners/lansan.png" },
    { name: "Ceynex", logo: "/images/partners/ceynex.jpg" },
    { name: "Hikvision", logo: "/images/partners/hikvision.png" },
    { name: "Ubiquiti UniFi", logo: "/images/partners/unifi.png" },
    { name: "UNV", logo: "/images/partners/unv.png" },
];

export function PartnersSection() {
    return (
        <section className="mt-10 py-12 bg-white border-b border-gray-100 overflow-hidden">
            <div className="container mx-auto px-4 mb-8 text-center">
                <p className="text-sm font-medium uppercase tracking-widest text-[#5b6b7c]">Trusted Partners</p>
            </div>

            <div className="relative w-full overflow-hidden group">
                {/* Gradient Masks */}
                <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
                <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />

                <div className="flex w-max animate-scroll hover:[animation-play-state:paused]">
                    {/* 3 Sets of logos for seamless looping */}
                    {[...PARTNERS, ...PARTNERS, ...PARTNERS].map((partner, index) => {
                        const logo = (
                            <div className="relative flex h-24 w-32 items-center justify-center">
                                <Image
                                    src={partner.logo}
                                    alt={partner.name}
                                    width={160}
                                    height={160}
                                    className="h-24 w-auto object-contain mix-blend-multiply"
                                />
                            </div>
                        );

                        return (
                            <div
                                key={`${partner.name}-${index}`}
                                className="mx-8 flex-shrink-0 cursor-pointer opacity-60 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
                            >
                                {"href" in partner && partner.href ? (
                                    <Link href={partner.href} aria-label={`${partner.name} brand page`}>
                                        {logo}
                                    </Link>
                                ) : (
                                    logo
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        .animate-scroll {
          animation: scroll 60s linear infinite;
        }
      `}</style>
        </section>
    );
}
